import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Etree} from '../../models/Etree';
import {Schedule} from '../../models/Schedule';
import {DatePipe} from '@angular/common';
import {saveAs} from 'file-saver';
import * as _ from 'lodash';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {BaseClientComponent} from '../base-client.component';
import {BwEtree, BwEtreeService, BwScheduleService, UpdateRequest, UpdateRequestService} from '../../generated';
import {EtreeService} from '../../services/etree.service';
import {environment} from '../../../environments/environment';
import {SelectItem} from '../../models/select-item';
import {BwJiraIssue} from '../../models/BwJiraIssue';
import {JiraPopOption, JiraService} from '../../services/jira.service';
import {Company} from '../../models/company';
import {UserLogged} from '../../models/userLogged';
import {MbelMagicMac} from '../../models/mbelMagicMac';

@Component({
  selector: 'app-bw-etree-overview',
  templateUrl: './bw-etree-overview.component.html',
  styleUrls: ['./bw-etree-overview.component.css']
})
export class BwEtreeOverviewComponent extends BaseClientComponent implements OnInit, OnDestroy {

  UPDATE_BANDWIDTH_ALLOCATION_TYPE = 'mbel.bw_allocation';
  UPDATE_MAC_ADRESS_TYPE = 'sps.mac_list';
  UPDATE_MBEL_MAC_ADRESS_TYPE = 'mbel.mac_list';
  UPDATE_BUFFER_PRIORITIES_TYPE = 'lcm.buffers';
  UPDATE_NX_LINK_SHARE_TYPE = 'nxls.bw_allocation';
  currentEtree: Etree;
  currentSchedule: Schedule;
  currentCompany: Company;
  loggedInUser: UserLogged;
  clientReferenceform: UntypedFormGroup;
  bandwidthForm: UntypedFormGroup;
  macUploadForm: UntypedFormGroup;
  mbelMacUploadForm: UntypedFormGroup;
  bufferPriorityForm: UntypedFormGroup;
  nxLinkshareForm: UntypedFormGroup;
  file: File;
  reader: FileReader;
  fileBuffer = null;
  fileLines: string[] = [];
  uploadedMacAddressArray: any = [];
  uploadedMbelMacAddressArray: any = [];
  uploadedMacAddressHeader = '';
  uploadedMbelMacAddressHeader = '';
  databaseMacAddressArray: any = [];
  databaseMbelMacAddressArray: any = [];
  databaseMacAddressHeader = '';
  databaseMbelMacAddressHeader = '';
  macAddressArray: any = [];
  mbelMacAddressArray: any = [];
  macAddressHeader = '';
  mbelMacAddressHeader = '';
  bandwidthHeader: string = null;
  nxLinkshareHeader: string = null;
  etreeDeprovisionedStatus = 'deprovisioned';
  csvDatabaseFileToDwonloadBlob: Blob = null;
  csvMbelDatabaseFileToDwonloadBlob: Blob = null;
  csvDatabaseFileToDwonloadName = '';
  csvMbelDatabaseFileToDwonloadName = '';
  bufferDataHeader: string = null;
  showSpscMacWarning = false;
  showMbelMacWarning = false;
  uploadOfMacAddresses = false;
  uploadOfMbelMacAddresses = false;
  uploadOfBufferPriorities = false;
  lastUpdatedAt: any;
  etreeMethods = [];
  marsUrl = environment.circuitMarsHubBaseLink;
  bwmEtreeUrl = environment.bwmEtreeUrl;
  etreeJsonData: any;
  isJirapopUp = false;
  jiraLink: string;
  isSendToJiraDisabled = false;
  crossConnectItemForJira: SelectItem[] = [];
  popsItemForJira: JiraPopOption[] = [];
  jiraCustomDescription = '';
  bwJiraIssue: BwJiraIssue = new BwJiraIssue();
  selectedPriority = 'support';
  successCreateJira = false;
  jiraIssueCode: string;
  selectedXcoForJira: any;
  selectedPopsForJira: any;
  jiraCreationError = false;
  displayJiraFeature: boolean;
  displayXcoDropDown = false;
  popSwitchStates: boolean[] = [];
  malformatedFile = false;
  malformatedFileSps = false;
  selectedParticipantForJira: any;
  participantsItemForJira: any[];

  constructor(
      public route: ActivatedRoute,
      public bwEtreeService: BwEtreeService,
      public bwScheduleService: BwScheduleService,
      public updateRequestService: UpdateRequestService,
      public formBuilder: UntypedFormBuilder,
      public datePipe: DatePipe,
      private etreeService: EtreeService,
      private _router: Router,
      public authenticationService: AuthenticationService,
      protected utilsService: UtilsService,
      protected http: HttpClient,
      private jiraService: JiraService,
  ) {
    super();
    this.reader = new FileReader();
    this.reader.onload = () => {
      this.fileBuffer = this.reader.result;
      this.fileLines = this.fileBuffer.split('\n');
    };
  }

  ngOnInit() {
    this.displayJiraFeature = environment.displayJiraFeature;
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    this.subscriptions.push(response$);
  }

  public ngOnChanges() {
    this.uploadedMacAddressArray = [];
    this.loggedInUser = this.authenticationService.userCurrent;
    this.currentCompany = this.loggedInUser.company;
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const etreeId = paramMap['params']['id'];
      // avoid reload when route change only for anchors:
      this.bwEtreeService.getBwEtreeItem(etreeId).subscribe({next: (etree) => {
            if (!etree) {
              this.redirectionToNotFound();
            }
            if (etree.source !== 'BWM') {
              this.redirectionToNotFound();
            }
            if (etree.status === this.etreeDeprovisionedStatus) {
              this.redirectionToNotFound();
            }
            if (!this.loggedInUser.permissions.isMckayUser && etree.hideOnPortal) {
              this.redirectionToNotFound();
            }
            this.macAddressArray = [];
            this.macAddressHeader = '';
            this.currentEtree = JSON.parse(etree.jsonData) as Etree;
            this.currentEtree.lastBwmUpdatedDate = this.formatDateTime(etree.lastBwmUpdatedDate);
            this.lastUpdatedAt = etree.lastBwmUpdatedDate;
            this.currentEtree.clientReference = etree.clientReference;
            this.currentEtree.announcementCategory = etree.announcementCategory;
            this.currentEtree.onGoingOutage = etree.onGoingOutage;
            this.currentEtree.updateRequests = etree.updateRequests;
            this.currentEtree.latestUpdateRequests = etree.latestUpdateRequests;
            this.currentEtree.marsCircuits = etree.marsCircuits;
            this.currentEtree.onGoingAnnouncement = etree.onGoingAnnouncement;
            this.currentEtree.announcementMessages = etree.announcementMessages;
            this.currentEtree.serviceTypeShort = etree.serviceTypeShort;
            this.initMethodsArray();
            if (this.currentEtree.latestUpdateRequests[this.UPDATE_BANDWIDTH_ALLOCATION_TYPE]) {
              this.prepareMbelBandwidth(this.currentEtree.latestUpdateRequests[this.UPDATE_BANDWIDTH_ALLOCATION_TYPE]);
            }
            if (this.currentEtree.latestUpdateRequests[this.UPDATE_MAC_ADRESS_TYPE]) {
              this.prepareMacTabledata(this.currentEtree.latestUpdateRequests[this.UPDATE_MAC_ADRESS_TYPE]);
            }
            if (this.currentEtree.latestUpdateRequests[this.UPDATE_MBEL_MAC_ADRESS_TYPE]) {
              this.prepareMbelMacTabledata(this.currentEtree.latestUpdateRequests[this.UPDATE_MBEL_MAC_ADRESS_TYPE]);
            }
            if (this.currentEtree.latestUpdateRequests[this.UPDATE_BUFFER_PRIORITIES_TYPE]) {
              this.prepareBuffersPriorities(this.currentEtree.latestUpdateRequests[this.UPDATE_BUFFER_PRIORITIES_TYPE]);
            }
            if (this.currentEtree.latestUpdateRequests[this.UPDATE_NX_LINK_SHARE_TYPE]) {
              this.prepareNxLinkShare(this.currentEtree.latestUpdateRequests[this.UPDATE_NX_LINK_SHARE_TYPE]);
            }
            this.getEtreeJsonData();
            this.bwScheduleService.getBwScheduleItem(etree.schedule.id).subscribe({
              next: (schedule) => {
                this.currentSchedule = JSON.parse(schedule.jsonData) as Schedule;
              }, error: (error: HttpResponse<any>) => {
                if (error.status === 404) {
                  this.redirectionToNotFound();
                } else {
                  this.utilsService.handleErrorWebservice$(error);
                }
              }
            });
            this.initForms();
            this.setXcoAndPopsValuesForJiraPopUp();

          }, error: (error: HttpResponse<any>) => {
        if (error.status === 404) {
          this.redirectionToNotFound();
        } else {
          this.utilsService.handleErrorWebservice$(error);
        }
      }});
    });
  }

  public initForms() {
    this.clientReferenceform = this.formBuilder.group({
      'clientReference': [this.currentEtree.clientReference, Validators.required],
    });
    this.clientReferenceform.patchValue({clientReference: this.currentEtree.clientReference});
    let lcmBandwidth = 0;
    let mbelBandwidth = 0;
    if (this.currentEtree.activeEtreeInjectionDemarcationPoint.activeClientConnectionPoints
        && this.currentEtree.activeEtreeInjectionDemarcationPoint.activeClientConnectionPoints.length > 0) {
      _.forEach(this.currentEtree.activeEtreeInjectionDemarcationPoint.activeClientConnectionPoints, (ccp) => {
        if (ccp.mbelAllocation === 'LCM') {
          lcmBandwidth = ccp.bwAllocation;
        } else if (ccp.mbelAllocation === 'MBEL') {
          mbelBandwidth = ccp.bwAllocation;
        }
      });
    }
    this.bandwidthForm = this.formBuilder.group({
      'lcmBandwidth': [lcmBandwidth, Validators.required],
      'mbelBandwidth': [mbelBandwidth, Validators.required],
    });
    this.macUploadForm = this.formBuilder.group({
      'macAdresseFile': ['', Validators.required],
    });
    this.mbelMacUploadForm = this.formBuilder.group({
      'macAdresseFile': ['', Validators.required],
    });
    if (this.currentEtree.priorities && this.currentEtree.priorities.length > 0) {
      const highPriorityEntry = this.currentEtree.priorities.find(p => p['global_priority'] === '4');
      const lowPriorityEntry = this.currentEtree.priorities.find(p => p['global_priority'] === '2');
      this.bufferPriorityForm = this.formBuilder.group({
        'highPriority': [highPriorityEntry ? highPriorityEntry['queue_size'] : '8'],
        'lowPriority': [lowPriorityEntry ? lowPriorityEntry['queue_size'] : '8', Validators.required],
      });
    } else {
      this.bufferPriorityForm = this.formBuilder.group({
        'highPriority': ['8'],
        'lowPriority': ['8', Validators.required],
      });
    }
    this.nxLinkshareForm = this.formBuilder.group({
      'nxls': [''],
      'neomb': ['', Validators.required],
    });
  }

  // client reference section
  public showClientreferenceErrorMessage(fieldName: string): boolean {
    return !this.clientReferenceform.controls[fieldName].valid;
  }

  public saveClientReference() {
    this.utilsService.lockUi();
    this.utilsService.lockUi();
    const etree = <BwEtree>{
      clientReference: this.clientReferenceform.value.clientReference,
    };
    this.bwEtreeService.putBwEtreeItem(this.currentEtree.id, etree).subscribe({
      next: () => {
        this.ngOnInit();
        this.utilsService.unlockUi();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error, 'Error in transmitting your request. Please contact site admin');
      }
    });
  }

  // Bandwidth section
  public showBandwidthFormErrorMessage(fieldName: string): boolean {
    return !this.bandwidthForm.controls[fieldName].valid;
  }

  public prepareMbelBandwidth(updateRequest: UpdateRequest) {
    if (updateRequest.jiraIssue) {
      const dateSentList = new Date(updateRequest.createdDate);
      const bandwidthData = updateRequest.jsonParams;
      this.bandwidthHeader = 'Last allocation <b> (LCM = ' + bandwidthData['mbel.bw_allocation']['lcm']
          + 'Mbps, MBEL=' + bandwidthData['mbel.bw_allocation']['mbel'] + ' Mbps)</b> has been sent to Mckay at: '
          + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
      this.bandwidthHeader += ' <span class="badge badge-info"><a href="' + this.getJiraLink(updateRequest.jiraIssue) + '" target="_blank">jira ' + updateRequest.jiraIssue + '</a></span>';
    }
  }

  public saveBandwidth() {
    this.utilsService.lockUi();
    const data = [];
    data.push({
      'mbel.bw_allocation': {
        'lcm': this.bandwidthForm.value.lcmBandwidth,
        'mbel': this.bandwidthForm.value.mbelBandwidth
      }
    });
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_BANDWIDTH_ALLOCATION_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.utilsService.unlockUi();
        this.ngOnInit();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error, 'Error in transmitting your request. Please contact site admin');
      }
    });
  }

  public showMacUploadFormErrorMessage(fieldName: string): boolean {
    return !this.macUploadForm.controls[fieldName].valid;
  }

  private createCsvFile(macList: any[]): Blob {
    const lineArray = [];
    const csvHeaders = ['source', 'destination'];
    const tmpCsvData = _.clone(macList);
    tmpCsvData.unshift(csvHeaders);
    tmpCsvData.forEach(function (infoArray) {
      const line = infoArray.join(',');
      lineArray.push(line);
    });
    const csvContent = lineArray.join('\n');
    return new Blob([csvContent], {
      type: 'text/csv'
    });
  }

  private csvFileName(prefix: string, dateSentList: Date): string {
    return prefix + this.currentEtree.name.split(' ').join('_') + '_'
        + this.datePipe.transform(dateSentList, 'yyyy_MM_dd') + '.csv';
  }

  public downloadMAcListAsCsv() {
    saveAs(this.csvDatabaseFileToDwonloadBlob, this.csvDatabaseFileToDwonloadName);
  }

  public clearMacFileUpload() {
    this.macAddressHeader = this.databaseMacAddressHeader;
    this.macAddressArray = this.databaseMacAddressArray;
    this.uploadedMacAddressArray = [];
    this.uploadedMacAddressHeader = '';
    this.showSpscMacWarning = false;
    this.malformatedFile = false;
  }

  public uploadMacFile(event) {
    this.malformatedFile = false;
    this.showSpscMacWarning = false;
    this.uploadedMacAddressArray = [];
    this.file = event.files[0];
    this.reader.readAsText(this.file);
    this.reader.onloadend = () => {
      const csv: string = this.reader.result as string;
      const allTextLinestmp = csv.split(/\r|\n|\r/);
      const allTextLinesBeforeRemoveComma = allTextLinestmp.filter(function (el) {
        return el !== null && el !== '' && el.trim() !== '';
      });

      const allTextLines = [];
      allTextLinesBeforeRemoveComma.map((line) => {
        allTextLines.push(this.removeTrailingComma(line))
      })
      allTextLines.map((line) => {
        const dataLine = line.split(',');
        if (!dataLine || dataLine.length !== 2 || (line.toLowerCase() !== 'source,destination' && this.hasInvalidMacAddress(dataLine))) {
          this.malformatedFile = true;

        }
      })
      if (this.malformatedFile === true)
        return;
      if (allTextLines[0].toLowerCase() !== 'source,destination') {
        allTextLines.unshift('source,destination');
      }
      if (allTextLines.length > 17) {
        this.showSpscMacWarning = true;
      }
      const headers = allTextLines[0].split(',');
      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        const data = allTextLines[i].split(',');
        if (data.length === headers.length && i > 0) {
          const tarr = [];

          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }
          this.uploadedMacAddressArray.push(tarr);
        }
      }

      this.uploadedMacAddressHeader = 'You are about to upload this mac adresses';

      this.macAddressArray = this.uploadedMacAddressArray;
      this.macAddressHeader = this.uploadedMacAddressHeader;
    };
  }

  removeTrailingComma(input: string): string {
    return input.replace(/,$/, "").replace(/"""/g, "");
    ;
  }

  public transmitMacFile() {
    this.utilsService.lockUi();
    const data = [];
    data.push({'sps.mac_list': this.uploadedMacAddressArray});
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_MAC_ADRESS_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.clearMacFileUpload();
        this.utilsService.unlockUi();
        this.uploadOfMacAddresses = true;
        this.ngOnInit();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error, 'Error in transmitting your request. Please contact site admin');
      }
    });
  }

  public downloadMbelMAcListAsCsv() {
    saveAs(this.csvMbelDatabaseFileToDwonloadBlob, this.csvMbelDatabaseFileToDwonloadName);
  }

  public clearMbelMacFileUpload() {
    this.mbelMacAddressHeader = this.databaseMbelMacAddressHeader;
    this.mbelMacAddressArray = this.databaseMbelMacAddressArray;
    this.uploadedMbelMacAddressArray = [];
    this.uploadedMbelMacAddressHeader = '';
    this.showMbelMacWarning = false;
    this.malformatedFileSps = false
  }

  public uploadMbelMacFile(event) {
    this.malformatedFileSps = false;
    this.showMbelMacWarning = false;
    this.uploadedMbelMacAddressArray = [];
    this.file = event.files[0];
    this.reader.readAsText(this.file);
    this.reader.onloadend = () => {
      const csv: string = this.reader.result as string;
      const allTextLinestmp = csv.split(/\r|\n|\r/);
      const allTextLinesBeforeRemoveComma = allTextLinestmp.filter(function (el) {
        return el !== null && el !== '';
      });
      const allTextLines = [];
      allTextLinesBeforeRemoveComma.map((line) => {
        allTextLines.push(this.removeTrailingComma(line))
      })
      allTextLines.map((line) => {
        const dataLine = line.split(',');
        if (!dataLine || dataLine.length !== 2 || (line.toLowerCase() !== 'source,destination' && this.hasInvalidMacAddress(dataLine))) {
          this.malformatedFileSps = true;
        }
      })
      if (this.malformatedFileSps === true)
        return;
      if (allTextLines[0].toLowerCase() !== 'source,destination') {
        allTextLines.unshift('source,destination');
      }
      if (allTextLines.length > 2) {
        this.showMbelMacWarning = true;
      }
      const headers = allTextLines[0].split(',');
      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        const data = allTextLines[i].split(',');
        if (data.length === headers.length && i > 0) {
          const tarr = [];

          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }
          this.uploadedMbelMacAddressArray.push(tarr);
        }
      }
      this.uploadedMbelMacAddressHeader = 'You are about to upload this mac adresses';

      this.mbelMacAddressArray = this.uploadedMbelMacAddressArray;
      this.mbelMacAddressHeader = this.uploadedMbelMacAddressHeader;
    };
  }

  public transmitMbelMacFile() {
    this.utilsService.lockUi();
    const data = [];
    data.push({'mbel.mac_list': this.uploadedMbelMacAddressArray});
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_MBEL_MAC_ADRESS_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.clearMbelMacFileUpload();
        this.utilsService.unlockUi();
        this.uploadOfMbelMacAddresses = true;
        this.ngOnInit();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error, 'Error in transmitting your request. Please contact site admin');
      }
    });
  }

  public showBufferPrioritiesErrorMessage(fieldName: string): boolean {
    return !this.bufferPriorityForm.controls[fieldName].valid;
  }

  public prepareBuffersPriorities(updateRequest: UpdateRequest) {
    if (updateRequest.jiraIssue) {
      const dateSentList = new Date(updateRequest.createdDate);
      const bufferData = updateRequest.jsonParams;
      this.bufferDataHeader = 'Last buffer priorities <b>(';
      if (this.currentEtree.spsEligible === true) {
        this.bufferDataHeader += 'High= ' + bufferData['lcm.buffers']['high'] + ',';
      }
      this.bufferDataHeader += 'Low= ' + bufferData['lcm.buffers']['low'] + ')</b> has been sent to Mckay at: '
          + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
      this.bufferDataHeader += ' <span class="badge badge-info"><a href="' + this.getJiraLink(updateRequest.jiraIssue) + '" target="_blank">jira ' + updateRequest.jiraIssue + '</a></span>';
    }
  }

  public saveBufferPriorities() {
    this.utilsService.lockUi();
    const data = [];
    data.push({
      'lcm.buffers': {
        'high': this.bufferPriorityForm.value.highPriority,
        'low': this.bufferPriorityForm.value.lowPriority
      }
    });
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_BUFFER_PRIORITIES_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.utilsService.unlockUi();
        this.uploadOfBufferPriorities = true;
        this.ngOnInit();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error, 'Error in transmitting your request. Please contact site admin');
      }
    });
  }

  public showNxLinkShareFormErrorMessage(fieldName: string): boolean {
    return !this.nxLinkshareForm.controls[fieldName].valid;
  }

  public prepareNxLinkShare(updateRequest: UpdateRequest) {
    if (updateRequest.jiraIssue) {
      const dateSentList = new Date(updateRequest.createdDate);
      const nxLinkshareData = updateRequest.jsonParams;
      this.nxLinkshareHeader = 'Last Nx Link Share parameters <b> (NXLS = ' + nxLinkshareData['nxls.bw_allocation']['nxls']
          + 'Neomb= ' + nxLinkshareData['nxls.bw_allocation']['neomb'] + ')</b> has been sent to Mckay at: '
          + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
      this.nxLinkshareHeader += ' <span style="font-size: 14px" class="badge badge-info"><a href="' + this.getJiraLink(updateRequest.jiraIssue) + '" target="_blank">jira ' + updateRequest.jiraIssue + '</a></span>';
    }
  }

  public saveNxLinkShare() {
    this.utilsService.lockUi();
    const data = [];
    data.push({
      'nxls.bw_allocation': {
        'nxls': this.nxLinkshareForm.value.nxls,
        'neomb': this.nxLinkshareForm.value.neomb
      }
    });
    const updateRequest = <UpdateRequest>{
      bwEtree: '/api/bw_etrees/' + this.currentEtree.id,
      status: 'sent',
      type: this.UPDATE_NX_LINK_SHARE_TYPE,
      jsonParams: data[0],
      userId: this.loggedInUser.id,
      username: this.loggedInUser.username,
      company: '/api/companies/' + this.loggedInUser.company.id
    };
    this.updateRequestService.postUpdateRequestCollection(updateRequest).subscribe({
      next: () => {
        this.utilsService.unlockUi();
        this.ngOnInit();
      }, error: error => {
        this.utilsService.handleErrorWebservice$(error, 'Error in transmitting your request. Please contact site admin');
      }
    });
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  downloadMbelMAcListAsSamleCsv() {
    const csvMbelDatabaseFileToDwonloadBlobSample = new Blob(['source,destination\n' +
    '5C-16-E2-61-7E-0E,CA-45-46-2D-7D-87\n'], {
      type: 'text/csv'
    });
    saveAs(csvMbelDatabaseFileToDwonloadBlobSample, 'mbel_mac_list_sample.csv');

  }

  downloadSpsMAcListAsSamleCsv() {
    const csvSpsDatabaseFileToDwonloadBlobSample = new Blob(['source,destination\n' +
    '5C-16-E2-61-7E-0E,CA-45-46-2D-7D-87\n' +
    '5C-16-E2-61-7E-0A,CA-45-46-2D-7D-86\n' +
    '5C-16-E2-61-7E-0B,CA-45-46-2D-7D-85\n' +
    '5C-16-E2-61-7E-0C,CA-45-46-2D-7D-84\n' +
    '5C-16-E2-61-7E-0D,CA-45-46-2D-7D-83\n' +
    '5C-16-E2-61-7E-00,CA-45-46-2D-7D-82\n' +
    '5C-16-E2-61-7E-0D,CA-45-46-2D-7D-81\n' +
    '5C-16-E2-61-7E-00,CA-45-46-2D-7D-80\n'], {
      type: 'text/csv'
    });
    saveAs(csvSpsDatabaseFileToDwonloadBlobSample, 'sps_mac_list_sample.csv');
  }

  getJiraLink(jiraId: string) {
    return 'https://mckay-brothers.atlassian.net/browse/' + jiraId;
  }

  downloadSpsMacAddressCsvFile(injectionMethod: string) {
    if (!this.currentEtree.macAdresses[injectionMethod]) {
      return;
    }
    let blobType: any;
    blobType = 'source,destination\n';
    let blocLine = [];

    for (const macAddress of this.currentEtree.macAdresses[injectionMethod]) {
      blocLine = [String(macAddress['source']).replace(/:/g, '-'),
        String(macAddress['destination']).replace(/:/g, '-')];
      blobType = blobType + blocLine.join(',') + '\n';
      blocLine = [];
    }
    const csv = new Blob([blobType], {
      type: 'text/csv'
    });
    const dateObject = new Date();
    const isoDate = this.datePipe.transform(dateObject, 'yyyyMMdd');
    saveAs(csv, isoDate + '_sps_mac_list.csv');
  }

  showLCMReception() {
    for (const rdp of this.currentEtree.etreeReceptionDemarcationPoints) {
      if (rdp['status'] === 'deprovisioned') {
        continue;
      }
      for (const ccp of rdp['activeClientConnectionPoints']) {
        if (ccp.mbelAllocation === 'LCM' && ccp.relatedInjectionCcp.mbelAllocation !== 'MBEL') {
          return true;
        }
      }
    }
    return false;
  }

  showMBELReception() {
    for (const rdp of this.currentEtree.etreeReceptionDemarcationPoints) {
      if (rdp['status'] === 'deprovisioned') {
        continue;
      }
      for (const ccp of rdp['activeClientConnectionPoints']) {
        if (ccp.mbelAllocation === 'MBEL' && ccp.relatedInjectionCcp.mbelAllocation === 'MBEL') {
          return true;
        }
      }
    }
    return false;
  }

  exportEtreeJsonData() {
    const blob = new Blob([this.etreeJsonData], {type: 'application/json'});
    saveAs(blob, this.etreeService.getFileNameForExportJson(this.currentEtree));
  }

  get macAdressesKeys(): string[] {
    const keys = this.currentEtree?.macAdresses ? Object.keys(this.currentEtree.macAdresses) : [];
    if (this.currentEtree?.priorities?.length > 0 && !keys.includes('LCM')) {
      keys.push('LCM');
    }
    return keys;
  }

  getEtreeJsonData() {
    this.etreeService.exportEtreeJsonData(this.currentEtree.id).subscribe(response => {
      this.etreeJsonData = response;
      const etree = JSON.parse(this.etreeJsonData);
      if (etree.mbelMagicMac && !Array.isArray(etree.mbelMagicMac)) {
        this.currentEtree.mbelMagicMac = etree.mbelMagicMac as MbelMagicMac;
      } else {
        this.currentEtree.mbelMagicMac = null;
      }
    });
  }

  private formatDateTime(dateIn: string) {
    if (!dateIn || dateIn.length === 0) {
      return '';
    }
    const date = dateIn.substr(0, 10);
    const time = dateIn.substr(11, 5);
    return date + ' ' + time;
  }

  private prepareMacTabledata(updateRequest: UpdateRequest) {
    this.macAddressArray = updateRequest.jsonParams['sps.mac_list'];
    const dateSentList = new Date(updateRequest.createdDate);
    if (updateRequest.jiraIssue) {
      this.macAddressHeader = 'This following mac adresses has been sent to Mckay at: '
          + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
      this.macAddressHeader += ' <span class="badge badge-info"><a href="' + this.getJiraLink(updateRequest.jiraIssue) + '" target="_blank">jira ' + updateRequest.jiraIssue + '</a></span>';

      this.databaseMacAddressArray = this.macAddressArray;
      this.databaseMacAddressHeader = this.macAddressHeader;
    }
    this.csvDatabaseFileToDwonloadBlob = this.createCsvFile(this.databaseMacAddressArray);
    this.csvDatabaseFileToDwonloadName = this.csvFileName('Mac_List', dateSentList);
  }

  private prepareMbelMacTabledata(updateRequest: UpdateRequest) {
    this.mbelMacAddressArray = updateRequest.jsonParams['mbel.mac_list'];
    const dateSentList = new Date(updateRequest.createdDate);
    if (updateRequest.jiraIssue) {
      this.mbelMacAddressHeader = 'This following mac adresses has been sent to Mckay at: '
          + this.datePipe.transform(dateSentList, 'yyyy/MM/dd H:mm');
      this.mbelMacAddressHeader += ' <span class="badge badge-info"><a href="' + this.getJiraLink(updateRequest.jiraIssue) + '" target="_blank">jira ' + updateRequest.jiraIssue + '</a></span>';
      this.databaseMbelMacAddressHeader = this.mbelMacAddressHeader;
    }
    this.databaseMbelMacAddressArray = this.mbelMacAddressArray;
    this.csvMbelDatabaseFileToDwonloadBlob = this.createCsvFile(this.databaseMbelMacAddressArray);
    this.csvMbelDatabaseFileToDwonloadName = this.csvFileName('Mbel_Mac_List', dateSentList);
  }

  showReception(method) {
    for (const rdp of this.currentEtree.etreeReceptionDemarcationPoints) {
      if (rdp['status'] === 'deprovisioned') {
        continue;
      }
      for (const ccp of rdp.activeClientConnectionPoints) {
        if (ccp.mbelAllocation === method) {
          return true;
        }
      }
    }
    return false;
  }

  showInjection(method) {
    return this.currentEtree.activeEtreeInjectionDemarcationPoint.activeClientConnectionPoints.filter(ccp => ccp.mbelAllocation === method).length > 0;
  }

  private initMethodsArray() {
    const rdpArray = [...this.currentEtree.etreeReceptionDemarcationPoints, ...this.currentEtree.etreeInjectionDemarcationPoint];
    if (rdpArray) {
      for (const rdp of rdpArray) {
        for (const ccp of rdp.activeClientConnectionPoints) {
          const mbelAllocation = ccp.mbelAllocation;
          if (mbelAllocation !== 'LCM' && mbelAllocation !== 'MBEL' && this.etreeMethods.indexOf(ccp.mbelAllocation) === -1) {
            this.etreeMethods.push(ccp.mbelAllocation);
          }
        }
      }
    }
  }

  gotoAnnoucementPage() {
    if (!this.currentEtree.announcementMessages) {
      return;
    }
    const userChoicesFiltersDefaultAnnouncementLog = {
      'subject': null,
      'message': null,
      'fromMail': null,
      'user': null,
      'sentDateFrom': null,
      'sentDateTo': null,
      'uuid': null,
    };
    const userChoicesActiveFilters = this.utilsService.loadUserPref('announcementLogFilter', userChoicesFiltersDefaultAnnouncementLog);
    userChoicesActiveFilters.uuid = this.currentEtree.announcementMessages;
    this.utilsService.saveUserData('announcementLogFilter', userChoicesActiveFilters);
    this._router.navigate(['/' + this.loggedInUser.company.uniqid + '/announcementLog']);
  }

  openSendJiraPopup() {
    if (!this.loggedInUser.permissions.isMckayUser) {
      this.prepareData();
    }
    this.isJirapopUp = true;
  }

  disableCreateIssueButton() {
    if (!this.jiraCustomDescription || this.jiraCustomDescription.length === 0) {
      return true;
    }
    return (!this.selectedXcoForJira || this.selectedXcoForJira.length === 0)
      && (!this.selectedPopsForJira || this.selectedPopsForJira.length === 0);
  }

  createIssue() {
    if (this.disableCreateIssueButton()) {
      this.isSendToJiraDisabled = true;
      return;
    }
    this.isSendToJiraDisabled = false;
    this.bwJiraIssue.reporter = this.loggedInUser;
    this.bwJiraIssue.createdBy = this.loggedInUser.username;
    this.bwJiraIssue.isSupport = this.selectedPriority === 'support';

    const issueText = this.jiraService.buildBwIssueText(
      this.currentSchedule.bundleName,
      [this.currentEtree.contractReference],
      this.popsItemForJira,
      this.selectedPopsForJira,
      this.selectedXcoForJira,
      this.jiraCustomDescription
    );

    this.utilsService.lockUi();
    this.jiraService.createJiraIssue({
      description: issueText.description,
      subject: issueText.subject,
      participantEmail: this.selectedParticipantForJira,
      createdByUserName: this.bwJiraIssue.reporter.username,
      createdByEmail: this.bwJiraIssue.reporter.email,
      isSupport: this.bwJiraIssue.isSupport,
      isMckayProject: true,
      isQuincyProject: false,
    }).subscribe((response) => {
      this.successCreateJira = true;
      this.jiraCreationError = false;
      this.jiraIssueCode = response['created_issue_key'];
      this.jiraLink = response['jira_link'];
      this.isJirapopUp = false;
      this.cancel();
      this.utilsService.unlockUi();
    }, () => {
      this.jiraCreationError = true;
      this.successCreateJira = false;
      this.isJirapopUp = false;
      this.cancel();
      this.utilsService.unlockUi();
    });
  }

  setXcoAndPopsValuesForJiraPopUp() {
    let injectionPops = [];
    let receptionPops = [];
    let uniqueInjectionsXcosValues = [];
    receptionPops = [...new Set(this.currentEtree.receptionPoints)];
    if (this.currentEtree && this.currentEtree.activeEtreeInjectionDemarcationPoint) {
      _.forEach(this.currentEtree.activeEtreeInjectionDemarcationPoint['activeClientConnectionPoints'], function (ccp) {
        injectionPops.push(ccp['popNameForInjectList']);
        uniqueInjectionsXcosValues.push(ccp['crossConnectId']);
      });
    }
    injectionPops = [...new Set(injectionPops)];
    uniqueInjectionsXcosValues = [...new Set(uniqueInjectionsXcosValues)];
    const pops: JiraPopOption[] = [];
    if (injectionPops && injectionPops.length > 0) {
      const injectionLabel = `${injectionPops.join(',')} (Inj)`;
      pops.push({label: injectionLabel, value: injectionLabel, kind: 'injection'});
    }
    if (receptionPops && receptionPops.length > 0) {
      const receptionLabel = `${receptionPops.join(',')} (Listen)`;
      pops.push({label: receptionLabel, value: receptionLabel, kind: 'reception'});
    }
    this.popsItemForJira = pops;
    const uniqueReceptionXcosValues = this.extractReceptionCrossConnect(this.currentEtree);
    const xcosValuesSet = new Set([...uniqueInjectionsXcosValues, ...uniqueReceptionXcosValues]);
    this.crossConnectItemForJira = Array.from(xcosValuesSet).map(value => ({
      label: value, value: value, id: this.currentEtree.id
    })).sort((a, b) => a.label.localeCompare(b.label));
  }

  extractReceptionCrossConnect(etree) {
    const crossConnectIds = [];
    if (etree.etreeReceptionDemarcationPoints != null) {
      etree.etreeReceptionDemarcationPoints.forEach((rdp) => {
        rdp.activeClientConnectionPoints.forEach((ccpRdp) => {
          crossConnectIds.push(ccpRdp.crossConnectId);
        });
      });
    }
    return crossConnectIds;
  }

  cancel() {
    this.isJirapopUp = false;
    this.jiraCustomDescription = '';
    this.selectedPopsForJira = [];
    this.selectedXcoForJira = [];
    this.displayXcoDropDown = false;
  }

  setIsSendTojiraflag() {
    this.isSendToJiraDisabled = false;
  }

  onSelectPop() {
    this.isSendToJiraDisabled = false;
  }

  onPopSwitchChange(i: number, event: any) {
    this.popSwitchStates[i] = event.checked;
    this.displayXcoDropDown = this.popSwitchStates.some(state => state);
  }

  isValidMacAddress(mac: string): boolean {
    const macRegex = /^([0-9A-Fa-f]{2}([-:])){5}[0-9A-Fa-f]{2}$/;
    return macRegex.test(mac);
  }

  hasInvalidMacAddress(macAddresses: string[]): boolean {
    return macAddresses.some(mac => !this.isValidMacAddress(mac));
  }

  private prepareData() {
    const currentUserEmail = this.loggedInUser.email;

    this.etreeService.getOperationUser(this.currentCompany.id).subscribe(
        (response: any[]) => {
          this.participantsItemForJira = response.map(user => ({
            label: user.username,
            value: user.email,
            id: user.id,
            disabled: user.email === currentUserEmail
          }));
          this.participantsItemForJira = _.sortBy(this.participantsItemForJira, ['label'])
          this.selectedParticipantForJira = this.participantsItemForJira
              .filter(user => user.disabled)
              .map(user => user.value);
        },
        () => {
          this.jiraCreationError = true;
        }
    );
  }

  getClassForCategory(announcementCategory: any) {
    return this.utilsService.getClassForAnnouncementCategory(announcementCategory);
  }

  getLabelFromAnnouncementCategory(announcementCategory: any) {
    if (announcementCategory === 'client_action_required') {
      return 'Client action required';
    }
    if (announcementCategory === 'emergency_maintenance') {
      return 'Emergency maintenance';
    }
    if (announcementCategory === 'scheduled_maintenance') {
      return 'Scheduled maintenance';
    }
    if (announcementCategory === 'service_change') {
      return 'Service change';
    }
    if (announcementCategory === 'marketing') {
      return 'Marketing';
    }
    return 'Announcement';
  }

  getCcpAd(ccp: any) {
    if (!ccp.activeDiversity)
      return '';
    switch (ccp.activeDiversity) {
      case true:
        return ' Active diversity Primary';
      case false:
        return ' Active diversity Secondary';
      default:
        return '';
    }
  }
}
